export default __webpack_public_path__ + "static/media/hi.bf743e90.png";